import { getCookie, setCookie, removeCookie } from 'tiny-cookie'
import { getAuth0Instance } from '@sennder/senn-node-auth0-frontend'
import { GetTokenSilentlyOptions } from '@auth0/auth0-spa-js'
import { AUTH0_USE_TOKEN_POPUP } from '@/common/config'

export type TokenPrefix = 'Bearer' | 'Token'
export type TokenParts = { prefix: TokenPrefix; data: string }

export const AUTH_TOKEN_COOKIE_EXPIRE_TIME = '7D'
export const AUTH_TOKEN_COOKIE_NAME = '' // TODO: Define the right cookie name here

export async function getAuth0Token(
  options?: GetTokenSilentlyOptions,
  usePopup = false,
  throwException = false
): Promise<string | null> {
  const defaultToken = getDefaultToken()

  if (defaultToken) {
    return defaultToken
  }

  let haveToUsePopup = usePopup

  if (options?.audience) {
    haveToUsePopup = AUTH0_USE_TOKEN_POPUP
  }

  return getAuth0TokenInternal(options, haveToUsePopup, throwException)
}

export async function getAuth0Header(
  options?: GetTokenSilentlyOptions,
  usePopup = false,
  throwException = false
): Promise<string | null> {
  const token = await getAuth0Token(options, usePopup, throwException)

  return token ? `Bearer ${token}` : null
}

function getDefaultToken() {
  const token = getCookie(AUTH_TOKEN_COOKIE_NAME)
  return token ? `Token ${token}` : null
}

async function getAuth0TokenInternal(
  options?: GetTokenSilentlyOptions,
  usePopup = false,
  throwException = false
): Promise<string | null> {
  const auth0Instance = getAuth0Instance()

  const isAuthenticated = await auth0Instance?.isAuthenticated()
  if (isAuthenticated) {
    return await auth0Instance.getToken(options, usePopup, throwException)
  }
  return null
}

export function setToken(token: string) {
  setCookie(AUTH_TOKEN_COOKIE_NAME, token, {
    expires: AUTH_TOKEN_COOKIE_EXPIRE_TIME,
  })
}

export function removeToken() {
  removeCookie(AUTH_TOKEN_COOKIE_NAME)
}

export function getTokenParts(token: string): TokenParts {
  if (!token || typeof token !== 'string') {
    throw Error(
      '[ts-website-project-sample-fast - TokenManager]: Cant get token parts. Token should be not empty and a string'
    )
  }

  const tokenParts = token.split(' ')

  if (tokenParts.length !== 2) {
    throw Error(
      `[ts-website-project-sample-fast - TokenManager]: Cant get parts for token ${token}. Token format is 'Prefix ***********...'`
    )
  }

  return { prefix: tokenParts[0] as TokenPrefix, data: tokenParts[1] }
}
